import React, { useState, useEffect, memo } from 'react';
import { Check, Sparkles, Gift, X, PartyPopper, Clock, ArrowRight, AlertCircle } from 'lucide-react';

const API_URL = 'https://api.nexusai.company';

// =====================================================
// SISTEMA DE MODALES GLOBAL - Inyecta directamente en DOM
// No depende del estado de React, funciona siempre
// =====================================================

const showTrialSuccessModal = (productName) => {
  // Crear contenedor si no existe
  let container = document.getElementById('trial-modal-root');
  if (!container) {
    container = document.createElement('div');
    container.id = 'trial-modal-root';
    document.body.appendChild(container);
  }

  // Generar confeti
  const colors = ['#10b981', '#22c55e', '#fbbf24', '#8b5cf6', '#ec4899', '#3b82f6'];
  const confettiHTML = Array.from({ length: 50 }, (_, i) => {
    const color = colors[Math.floor(Math.random() * colors.length)];
    const left = Math.random() * 100;
    const delay = Math.random() * 0.5;
    const duration = 2 + Math.random() * 2;
    const size = 8 + Math.random() * 8;
    const isCircle = size > 12;
    return `<div style="
      position: absolute;
      top: -20px;
      left: ${left}%;
      width: ${size}px;
      height: ${size}px;
      background: ${color};
      border-radius: ${isCircle ? '50%' : '2px'};
      animation: confettiFall ${duration}s ease-out ${delay}s forwards;
      opacity: 0;
      z-index: 100001;
    "></div>`;
  }).join('');

  // Inyectar HTML del modal
  container.innerHTML = `
    <style>
      @keyframes fadeInModal {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes modalPopIn {
        0% { opacity: 0; transform: scale(0.7) translateY(30px); }
        100% { opacity: 1; transform: scale(1) translateY(0); }
      }
      @keyframes confettiFall {
        0% { opacity: 1; transform: translateY(0) rotate(0deg); }
        100% { opacity: 0; transform: translateY(100vh) rotate(720deg); }
      }
      @keyframes pulseIcon {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.08); }
      }
      #trial-success-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(10px);
        z-index: 100000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: fadeInModal 0.3s ease;
      }
      #trial-success-modal {
        position: relative;
        background: linear-gradient(145deg, #1e293b 0%, #0f172a 100%);
        border-radius: 28px;
        padding: 48px 40px;
        max-width: 440px;
        width: 100%;
        text-align: center;
        box-shadow:
          0 30px 60px rgba(0, 0, 0, 0.6),
          0 0 120px rgba(16, 185, 129, 0.25),
          inset 0 1px 0 rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(16, 185, 129, 0.35);
        animation: modalPopIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.4);
        z-index: 100002;
      }
      #trial-close-btn {
        position: absolute;
        top: 18px;
        right: 18px;
        background: rgba(255, 255, 255, 0.1);
        border: none;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.5);
        transition: all 0.25s ease;
        font-size: 20px;
      }
      #trial-close-btn:hover {
        background: rgba(255, 255, 255, 0.2);
        color: white;
        transform: rotate(90deg);
      }
      #trial-icon-wrapper {
        width: 90px;
        height: 90px;
        margin: 0 auto 28px;
        background: linear-gradient(145deg, #10b981 0%, #059669 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 15px 50px rgba(16, 185, 129, 0.5);
        animation: pulseIcon 2s infinite;
      }
      #trial-icon-wrapper svg {
        width: 45px;
        height: 45px;
        color: white;
      }
      #trial-title {
        font-size: 2rem;
        font-weight: 800;
        margin-bottom: 10px;
        background: linear-gradient(135deg, #10b981, #34d399);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      #trial-product-name {
        font-size: 1.15rem;
        color: rgba(255, 255, 255, 0.95);
        margin-bottom: 28px;
        font-weight: 600;
      }
      #trial-info-box {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 14px;
        padding: 18px 26px;
        background: rgba(16, 185, 129, 0.12);
        border-radius: 18px;
        border: 1px solid rgba(16, 185, 129, 0.25);
        margin-bottom: 26px;
      }
      #trial-info-box svg {
        width: 28px;
        height: 28px;
        color: #10b981;
        flex-shrink: 0;
      }
      #trial-days-text {
        color: #10b981;
        font-weight: 700;
        font-size: 1.35rem;
        margin: 0;
        line-height: 1.2;
      }
      #trial-access-text {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.9rem;
        margin: 4px 0 0 0;
      }
      #trial-message {
        color: rgba(255, 255, 255, 0.75);
        font-size: 1rem;
        margin-bottom: 32px;
        line-height: 1.7;
      }
      #trial-message strong {
        color: white;
      }
      #trial-action-btn {
        width: 100%;
        padding: 18px 28px;
        background: linear-gradient(145deg, #10b981 0%, #059669 100%);
        border: none;
        border-radius: 16px;
        color: white;
        font-size: 1.1rem;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-shadow: 0 12px 35px rgba(16, 185, 129, 0.45);
        transition: all 0.3s ease;
      }
      #trial-action-btn:hover {
        transform: translateY(-3px);
        box-shadow: 0 18px 45px rgba(16, 185, 129, 0.55);
      }
      #trial-action-btn svg {
        width: 20px;
        height: 20px;
      }
    </style>
    <div id="trial-success-backdrop">
      ${confettiHTML}
      <div id="trial-success-modal">
        <button id="trial-close-btn">✕</button>
        <div id="trial-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5.8 11.3 2 22l10.7-3.79"></path>
            <path d="M4 3h.01"></path>
            <path d="M22 8h.01"></path>
            <path d="M15 2h.01"></path>
            <path d="M22 20h.01"></path>
            <path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"></path>
            <path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17"></path>
            <path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7"></path>
            <path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"></path>
          </svg>
        </div>
        <h2 id="trial-title">¡Prueba Activada!</h2>
        <p id="trial-product-name">${productName}</p>
        <div id="trial-info-box">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <div style="text-align: left;">
            <p id="trial-days-text">7 días gratis</p>
            <p id="trial-access-text">Acceso completo a todas las funciones</p>
          </div>
        </div>
        <p id="trial-message">
          Tu prueba gratuita está lista. Ve a <strong>"Mis Productos"</strong> para comenzar a usar todas las funciones.
        </p>
        <button id="trial-action-btn">
          <span>¡Entendido!</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>
  `;

  // Agregar eventos de cierre
  const closeModal = () => {
    container.innerHTML = '';
  };

  document.getElementById('trial-close-btn').addEventListener('click', closeModal);
  document.getElementById('trial-action-btn').addEventListener('click', closeModal);
  document.getElementById('trial-success-backdrop').addEventListener('click', (e) => {
    if (e.target.id === 'trial-success-backdrop') {
      closeModal();
    }
  });

  // Cerrar con ESC
  const handleEsc = (e) => {
    if (e.key === 'Escape') {
      closeModal();
      document.removeEventListener('keydown', handleEsc);
    }
  };
  document.addEventListener('keydown', handleEsc);

  console.log('🎉 [Modal] Modal de éxito mostrado correctamente para:', productName);
};

const showTrialErrorModal = (message) => {
  // Crear contenedor si no existe
  let container = document.getElementById('trial-modal-root');
  if (!container) {
    container = document.createElement('div');
    container.id = 'trial-modal-root';
    document.body.appendChild(container);
  }

  // Inyectar HTML del modal de error
  container.innerHTML = `
    <style>
      @keyframes fadeInModal {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes modalPopIn {
        0% { opacity: 0; transform: scale(0.7); }
        100% { opacity: 1; transform: scale(1); }
      }
      #trial-error-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(10px);
        z-index: 100000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: fadeInModal 0.3s ease;
      }
      #trial-error-modal {
        position: relative;
        background: linear-gradient(145deg, #1e293b 0%, #0f172a 100%);
        border-radius: 24px;
        padding: 44px 36px;
        max-width: 400px;
        width: 100%;
        text-align: center;
        box-shadow:
          0 25px 50px rgba(0, 0, 0, 0.5),
          0 0 100px rgba(239, 68, 68, 0.2);
        border: 1px solid rgba(239, 68, 68, 0.35);
        animation: modalPopIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        z-index: 100001;
      }
      #error-close-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        background: rgba(255, 255, 255, 0.1);
        border: none;
        border-radius: 50%;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.5);
        transition: all 0.25s ease;
        font-size: 18px;
      }
      #error-close-btn:hover {
        background: rgba(255, 255, 255, 0.2);
        color: white;
      }
      #error-icon-wrapper {
        width: 80px;
        height: 80px;
        margin: 0 auto 24px;
        background: linear-gradient(145deg, #ef4444 0%, #dc2626 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 12px 40px rgba(239, 68, 68, 0.45);
      }
      #error-icon-wrapper svg {
        width: 40px;
        height: 40px;
        color: white;
      }
      #error-title {
        font-size: 1.6rem;
        font-weight: 700;
        color: #ef4444;
        margin-bottom: 18px;
      }
      #error-message {
        color: rgba(255, 255, 255, 0.85);
        font-size: 1.05rem;
        margin-bottom: 28px;
        line-height: 1.65;
      }
      #error-action-btn {
        width: 100%;
        padding: 16px 24px;
        background: linear-gradient(145deg, #ef4444 0%, #dc2626 100%);
        border: none;
        border-radius: 14px;
        color: white;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        box-shadow: 0 10px 30px rgba(239, 68, 68, 0.35);
        transition: all 0.3s ease;
      }
      #error-action-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 40px rgba(239, 68, 68, 0.45);
      }
    </style>
    <div id="trial-error-backdrop">
      <div id="trial-error-modal">
        <button id="error-close-btn">✕</button>
        <div id="error-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h2 id="error-title">Error</h2>
        <p id="error-message">${message}</p>
        <button id="error-action-btn">Cerrar</button>
      </div>
    </div>
  `;

  // Agregar eventos de cierre
  const closeModal = () => {
    container.innerHTML = '';
  };

  document.getElementById('error-close-btn').addEventListener('click', closeModal);
  document.getElementById('error-action-btn').addEventListener('click', closeModal);
  document.getElementById('trial-error-backdrop').addEventListener('click', (e) => {
    if (e.target.id === 'trial-error-backdrop') {
      closeModal();
    }
  });

  // Cerrar con ESC
  const handleEsc = (e) => {
    if (e.key === 'Escape') {
      closeModal();
      document.removeEventListener('keydown', handleEsc);
    }
  };
  document.addEventListener('keydown', handleEsc);
};

// =====================================================
// Estilos base para los botones 3D
// =====================================================
const button3DStyles = {
  base: {
    width: '100%',
    padding: '14px 20px',
    borderRadius: '16px',
    fontWeight: 700,
    fontSize: '0.95rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    position: 'relative',
    zIndex: 100,
    pointerEvents: 'auto'
  },
  trial: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)',
    color: 'white',
    boxShadow: '0 10px 30px rgba(16, 185, 129, 0.4), 0 4px 10px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.2)'
  },
  trialHover: {
    transform: 'translateY(-3px)',
    boxShadow: '0 15px 40px rgba(16, 185, 129, 0.5), 0 8px 15px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.2)'
  },
  active: {
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 50%, #15803d 100%)',
    color: 'white',
    boxShadow: '0 10px 30px rgba(34, 197, 94, 0.3), 0 4px 10px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.2)',
    cursor: 'default'
  },
  expired: {
    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%)',
    color: 'white',
    boxShadow: '0 10px 30px rgba(245, 158, 11, 0.4), 0 4px 10px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.2)'
  },
  loading: {
    background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
    color: 'white',
    boxShadow: '0 6px 20px rgba(107, 114, 128, 0.3)',
    cursor: 'wait'
  },
  notAuth: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)',
    color: 'white',
    boxShadow: '0 10px 30px rgba(16, 185, 129, 0.4), 0 4px 10px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.2)'
  }
};

// =====================================================
// Componente Principal - Memoizado
// =====================================================
const TrialButtonForPurchase = memo(({
  product,
  currentUserId,
  pricingMode,
  onTrialActivated,
  openPaymentModal,
  refreshUserData
}) => {
  const [isActivating, setIsActivating] = useState(false);
  const [trialStatus, setTrialStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasChecked, setHasChecked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (currentUserId && !hasChecked) {
      checkTrialStatus();
      setHasChecked(true);
    } else if (!currentUserId) {
      setLoading(false);
    }
  }, [currentUserId, product.product_key]);

  const checkTrialStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/trial/status/${product.product_key}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('nexusai-token')}`
        }
      });
      const data = await response.json();

      if (data.success) {
        setTrialStatus(data.data);
      }
    } catch (error) {
      console.error('Error verificando estado de prueba:', error);
    } finally {
      setLoading(false);
    }
  };

  const activateTrial = async () => {
    if (!currentUserId) {
      showTrialErrorModal('Debes iniciar sesión para activar una prueba gratuita');
      return;
    }

    setIsActivating(true);
    try {
      const response = await fetch(`${API_URL}/api/trial/activate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('nexusai-token')}`
        },
        body: JSON.stringify({
          userId: currentUserId,
          productKey: product.product_key
        })
      });

      const data = await response.json();

      if (data.success) {
        // Actualizar estado local
        setTrialStatus({
          status: 'trial',
          current_status: 'active_trial',
          expiration_date: data.expirationDate,
          days_remaining: 7
        });

        // MOSTRAR MODAL DE ÉXITO - Función global, no depende de React
        showTrialSuccessModal(product.name);

        // Refrescar datos en segundo plano
        setTimeout(async () => {
          if (refreshUserData) {
            try {
              await refreshUserData();
            } catch (e) {
              console.error('Error en refreshUserData:', e);
            }
          }
          if (onTrialActivated) {
            try {
              await onTrialActivated(product.product_key);
            } catch (e) {
              console.error('Error en onTrialActivated:', e);
            }
          }
        }, 300);

      } else {
        showTrialErrorModal(data.message || 'No se pudo activar la prueba gratuita');
      }
    } catch (error) {
      console.error('Error en activateTrial:', error);
      showTrialErrorModal('Error al activar la prueba gratuita. Inténtalo de nuevo.');
    } finally {
      setIsActivating(false);
    }
  };

  // Si no está autenticado
  if (!currentUserId) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          onClick={() => {
            showTrialErrorModal('Debes crear una cuenta para activar una prueba gratuita');
          }}
          style={{
            ...button3DStyles.base,
            ...button3DStyles.notAuth,
            ...(isHovered ? button3DStyles.trialHover : {})
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Gift size={18} />
          <span>Prueba Gratis 7 días</span>
        </button>
        <p style={{
          fontSize: '0.75rem',
          textAlign: 'center',
          color: 'rgba(255,255,255,0.7)',
          margin: 0
        }}>
          Crea una cuenta gratis para empezar
        </p>
      </div>
    );
  }

  // Loading
  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          disabled
          style={{
            ...button3DStyles.base,
            ...button3DStyles.loading
          }}
        >
          <div style={{
            width: '18px',
            height: '18px',
            border: '2px solid rgba(255,255,255,0.3)',
            borderTopColor: 'white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <span>Verificando...</span>
        </button>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Si ya tiene prueba activa o suscripción
  if (trialStatus && ['trial', 'active', 'active_trial'].includes(trialStatus.current_status)) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          disabled
          style={{
            ...button3DStyles.base,
            ...button3DStyles.active
          }}
        >
          <Check size={18} strokeWidth={3} />
          <span>
            {trialStatus.current_status === 'active_trial'
              ? 'Prueba Activa'
              : 'Ya tienes acceso'
            }
          </span>
          <Sparkles size={16} style={{ marginLeft: '4px' }} />
        </button>
        <p style={{
          fontSize: '0.75rem',
          textAlign: 'center',
          color: 'white',
          margin: 0,
          fontWeight: 600,
          textShadow: '0 1px 2px rgba(0,0,0,0.2)'
        }}>
          Ve a "Mis Productos" para acceder
        </p>
      </div>
    );
  }

  // Si la prueba expiró
  if (trialStatus && trialStatus.current_status === 'expired') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div style={{
          fontSize: '0.75rem',
          color: '#fbbf24',
          textAlign: 'center',
          fontWeight: 600,
          padding: '6px 12px',
          background: 'rgba(251, 191, 36, 0.1)',
          borderRadius: '8px',
          border: '1px solid rgba(251, 191, 36, 0.3)'
        }}>
          Tu prueba gratuita expiró
        </div>
        <button
          onClick={() => {
            const productInfo = {
              name: product.name,
              price: parseFloat(product.price),
              key: product.product_key,
              description: product.description,
              category: product.category,
              billing_cycle: pricingMode,
              period: pricingMode === 'annual' ? '/año' : '/mes'
            };
            openPaymentModal(productInfo);
          }}
          style={{
            ...button3DStyles.base,
            ...button3DStyles.expired,
            ...(isHovered ? { transform: 'translateY(-3px)', boxShadow: '0 15px 40px rgba(245, 158, 11, 0.5), 0 8px 15px rgba(0,0,0,0.15)' } : {})
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <span>Suscribirse Ahora</span>
        </button>
      </div>
    );
  }

  // Si no tiene prueba, mostrar botón para activarla
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <button
        onClick={activateTrial}
        disabled={isActivating}
        style={{
          ...button3DStyles.base,
          ...button3DStyles.trial,
          ...(isHovered && !isActivating ? button3DStyles.trialHover : {}),
          opacity: isActivating ? 0.8 : 1
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {isActivating ? (
          <>
            <div style={{
              width: '18px',
              height: '18px',
              border: '2px solid rgba(255,255,255,0.3)',
              borderTopColor: 'white',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            <span>Activando...</span>
          </>
        ) : (
          <>
            <Gift size={18} />
            <span>Prueba Gratis 7 días</span>
            <Sparkles size={16} style={{ marginLeft: '2px' }} />
          </>
        )}
      </button>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        fontSize: '0.75rem',
        color: 'white',
        textShadow: '0 1px 2px rgba(0,0,0,0.2)'
      }}>
        <Check size={12} style={{ color: 'white' }} />
        <span>Sin tarjeta • Sin compromiso</span>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.currentUserId === nextProps.currentUserId &&
    prevProps.product.product_key === nextProps.product.product_key &&
    prevProps.pricingMode === nextProps.pricingMode
  );
});

TrialButtonForPurchase.displayName = 'TrialButtonForPurchase';

export default TrialButtonForPurchase;
